var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 技术支持：武汉讯网信息技术有限公司 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }